<template>
    <div class="environment">
      <div class="container banner">
        <img src="../../static/img/about/banner.png" alt="">
        <div class="content">
          <div class="nav-title">
            <h1 class="title-name">环境介绍</h1>
            <hr>
          </div>
          <div class="article">
            <h4>入住房间</h4>
            <p>月子中心设13间宽大舒适套房，其中两间VIP高级套房。房间布置温馨典雅，推开窗户，满眼春色，周边无商业大厦，安静宜人。暂时避开身后繁华，隐入这片私密的花园，安逸、悠闲，看着宝宝粉嫩的小脸，内心幸福荡漾，就让您和宝宝徜徉在温暖的阳光里遐思。</p>
            <div class="pic-box">
              <img src="../../static/img/envi/ill1.png" alt="">
              <img src="../../static/img/envi/ill2.png" alt="">
            </div>
            <h4>公寓式单间</h4>
            <p>房型设计简洁、流畅。点缀着点点花纹的被单、时尚而又温馨的宝宝小床，淡雅的窗帘、衣柜，一件件都那样可爱，温馨，给人晴朗的心情。宽大的窗台，开阔的视野，阳光在这里，给温馨的房间进一步添上明亮、温暖的色调，一如您越来越幸福、温暖的生活。</p>
            <p>
              本中心还特设两间高级VIP套房，一房一厅一卫，这里不仅仅是您产后身心休憩的场所，更是您接待亲人朋友、会客休闲的“小家”，奢华而低调。秉承朝南之势，采光充足、视野开阔，露天宽大阳台，呼吸着纯净的空气，淹城景色尽收眼底，给您和宝宝更加优渥、尊贵的享受。<br>
              在窗前、在客厅、在沙发上……，你可以尽情挥洒心情，不受拘束的空间，不禁放宽了人的心境，月子带给您的不仅仅是健康，更是一片美丽心情。<br>
              或者听宝宝低声呢喃，或者与亲朋一起喜笑颜开，或者出门与新妈妈们分享彼此的心情，您在这里如同在家里，自在而又轻松。<br>
            </p>
            <p>所有房间配备超大双人床，婴儿床，独立宽敞的干湿分离卫生间，给产后妈妈疲惫的身心一个安逸舒适的自在空间。房间内独立新风循环中央空调系统和空气净化加湿设施，使您四季如春。还有宝宝洗澡浴缸，独立空调，网络电视，网络，软水直饮水过滤器，奶瓶消毒器，暖奶器等。</p>
            <div class="pic-box">
              <img src="../../static/img/envi/ill3.png" alt="">
              <img src="../../static/img/envi/ill4.png" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "environment"
    }
</script>

<style scoped lang="less">
  .environment{
    .banner{
      img{
        width: 100%;
        margin-bottom: 60px;
      }
    }
    .article{
      h4{
        font-size: 20px;
        margin-bottom: 18px;
      }
      p{
        margin-bottom: 36px;
        line-height: 28px;
        color: #666666;
      }
      .pic-box{
        display: flex;
        justify-content: space-between;
        img{
          width: 595px;
          height: 410px;
          margin-bottom: 36px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/environment.vue